// TODO 有些英文翻译需要完善
export default {
  appLayout: {
    logout: 'logout',
    exit: 'Logout',
  },
  datepicker: {
    selectDate: 'Select date',
    selectTime: 'Select time',
    startTime: 'Start Time',
    endTime: 'End Time',
    clear: 'Clear',
    ok: 'OK',
    datePanelLabel: '[yyyy] [Mmm]',
    month1: 'January',
    month2: 'February',
    month3: 'March',
    month4: 'April',
    month5: 'May',
    month6: 'June',
    month7: 'July',
    month8: 'August',
    month9: 'September',
    month10: 'October',
    month11: 'November',
    month12: 'December',
    year: '{year}',
    weekStartDay: '0',
    day: '{day}',
    weeks: {
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
    },
    months: {
      m1: 'Jan',
      m2: 'Feb',
      m3: 'Mar',
      m4: 'Apr',
      m5: 'May',
      m6: 'Jun',
      m7: 'Jul',
      m8: 'Aug',
      m9: 'Sep',
      m10: 'Oct',
      m11: 'Nov',
      m12: 'Dec',
    },
  },
  modalCard: {
    accept: 'Confirm',
    cancel: 'Cancel',
  },
  pagination: {
    goto: 'Go to',
    total: 'Total {total}',
    pageClassifier: '',
  },
  searchBox: {
    searchText: 'Search',
    searchBoxText: 'Filter',
    hideAdvFilter: 'Hide advanced',
    expandAdvFilter: 'Expand advanced',
  },
  transfer: {
    placeholder: 'Please enter search content',
    leftTitle: 'Source',
    rightTitle: 'Target',
    nodata: 'No Data',
    nomatch: 'No matching data',
  },
  upload: {
    uploading: 'Uploading...',
    failed: 'Upload failed',
    retry: 'Please try again',
  },
}
